import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BeneficiaryDocumentTypeResponseDto } from '@app/core/model/beneficiary/beneficiary-document-type.dto';
import { BeneficiaryService } from '@app/core/services/beneficiary.service';
import { ExceptionalBeneficiaryService } from '@app/core/services/exceptional-beneficiary.service';
import { SharedModule } from '@app/shared/shared.module';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { DocumentTypeEnum } from '@app/core/model/common/enums/document-type.enum';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-check-exceptional-beneficiary',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './check-exceptional-beneficiary.component.html',
  styleUrl: './check-exceptional-beneficiary.component.scss'
})
export class CheckExceptionalBeneficiaryComponent implements OnInit{
  documentTypes: BeneficiaryDocumentTypeResponseDto[] = [];
  formCheckExceptionalBeneficiary: FormGroup;
  isExceptionalBeneficiary: boolean = false;
  public currentDocType: string | null = null;
  private readonly blacklistEnrollmentMessage = 'Este usuario no está autorizado para enrolarse ni recibir pagos por este medio.';


  constructor(
    private fb: FormBuilder,
    private exceptionBeneficiaryService: ExceptionalBeneficiaryService,
    private _beneficiaryService: BeneficiaryService,
    private _activatedRoute: ActivatedRoute,
    private activeModal: NgbActiveModal
  ) {
    this.formCheckExceptionalBeneficiary = this.fb.group({
          documentType: [null, Validators.required],
          documentNumber: ['', Validators.required]
        })
  }

  ngOnInit(): void {
    this.initData();
    this.addInputValidation();
  }

  initData(): void {
        forkJoin({
          documentTypes: this._beneficiaryService.getDocumentTypes(),
        }).subscribe(({ documentTypes}) => {
          this.documentTypes = documentTypes.data;
          console.log(this.documentTypes);
        });
  }

  checkExceptionalBeneficiary(): void {
    const formValues = this.formCheckExceptionalBeneficiary.value;

    this._beneficiaryService
      .isDocumentBlacklisted(formValues.documentType.id, formValues.documentNumber)
      .subscribe((blacklistResponse) => {
        if (blacklistResponse.data) {
          Swal.fire({
            title: 'Registro no autorizado',
            text: this.blacklistEnrollmentMessage,
            icon: 'warning',
            confirmButtonText: 'Cancelar',
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(() => this.activeModal.close(null));
          return;
        }

        this.checkExceptionalBeneficiaryAfterBlacklist();
      });
  }

  private checkExceptionalBeneficiaryAfterBlacklist(): void {
    const formValues = this.formCheckExceptionalBeneficiary.value;

    this.exceptionBeneficiaryService
      .checkIsExceptionalBeneficiary(formValues.documentNumber)
      .subscribe((response) => {

        const payload = {
          isExceptional: !!response.data,
          dni: formValues.documentNumber,
          documentType: formValues.documentType
        }

        if(response.data){
          Swal.fire({
            title: 'Beneficiario Excepcional',
            text: 'DNI ingresado es un beneficiario excepcional. Ahora podrá registrar el número de documento y el CCI del destinatario al que desea que se le deposite el abono.',
            icon: 'info',
            confirmButtonText: 'Aceptar'
          });
        
          this.activeModal.close(payload);
          
        }
        this.activeModal.close(payload);
        
        
      });
  }

  addInputValidation(): void {
  this.formCheckExceptionalBeneficiary.get('documentType')?.valueChanges.subscribe((docTypeValue) => {
    console.log('documentType value:', docTypeValue);
    const docNumberControl = this.formCheckExceptionalBeneficiary.get('documentNumber');

    if (!docNumberControl) return;

    // Limpiar validadores previos
    docNumberControl.clearValidators();

    const type = typeof docTypeValue === 'string' ? docTypeValue : docTypeValue?.type;
    this.currentDocType = type?.toUpperCase() || null; // Guardamos el tipo actual

    switch (this.currentDocType) {
      case DocumentTypeEnum.DNI:
        docNumberControl.setValidators([
          Validators.required,
          Validators.pattern(/^\d{8}$/)
        ]);
        break;

      case DocumentTypeEnum.RUC:
        docNumberControl.setValidators([
          Validators.required,
          Validators.pattern(/^\d{11}$/)
        ]);
        break;

      case DocumentTypeEnum.CE:
        docNumberControl.setValidators([
          Validators.required,
          Validators.pattern(/^[a-zA-Z0-9]{9,12}$/)
        ]);
        break;

      case DocumentTypeEnum.PAS:
        docNumberControl.setValidators([
          Validators.required,
          Validators.pattern(/^[a-zA-Z0-9]{6,12}$/)
        ]);
        break;

      default:
        docNumberControl.setValidators(Validators.required);
    }

    docNumberControl.updateValueAndValidity();
  });
}

  validateDocNumberInput(event: KeyboardEvent): boolean {
  const key = event.key;

  if (this.currentDocType === 'DNI' || this.currentDocType === 'RUC') {
    const isNumber = /^[0-9]$/.test(key);
    if (!isNumber) {
      event.preventDefault();
      return false;
    }
  }

  if (this.currentDocType === 'PAS' || this.currentDocType === 'CE') {
    const isAlphanumeric = /^[a-zA-Z0-9]$/.test(key);
    if (!isAlphanumeric) {
      event.preventDefault();
      return false;
    }
  }

  return true;
  }


  public cancelar() {
    this.activeModal.close(null);
  }
}
